module.exports = __webpack_public_path__ + "img/RTW.17d77b24.svg";